<div class="p-3 pt-3 row wrapper">
  <ng-content></ng-content>
</div>
